const expressionConfig = {
	/**
	 * Arithmetic Operators
	 */
	abs: {
		mongoConvertor: expr => ({
			$abs: expr
		}),
		numArguments: 1
	},
	ceil: {
		mongoConvertor: expr => ({
			$ceil: expr
		}),
		numArguments: 1
	},
	divide: {
		mongoConvertor: (expr1, expr2) => ({
			$divide: [expr1, expr2]
		}),
		numArguments: 2
	},
	floor: {
		mongoConvertor: expr => ({
			$floor: expr
		}),
		numArguments: 1
	},
	mod: {
		mongoConvertor: (expr1, expr2) => ({
			$mod: [expr1, expr2]
		}),
		numArguments: 2
	},
	mul: {
		mongoConvertor: (...args) => ({
			$multiply: [...args]
		}),
		numArguments: 2,
		allowMultiple: true
	},
	sqrt: {
		mongoConvertor: expr => ({
			$sqrt: expr
		}),
		numArguments: 1
	},
	sub: {
		mongoConvertor: (expr1, expr2) => ({
			$subtract: [expr1, expr2]
		}),
		numArguments: 2
	},
	trunc: {
		mongoConvertor: expr => ({
			$trunc: expr
		}),
		numArguments: 1
	},
	sum: {
		mongoConvertor: (...args) => ({
			$sum: [...args]
		}),
		numArguments: 2,
		allowMultiple: true,
		mongoAggConvertor: expr => ({
			$sum: expr
		}),
		numAggArguments: 1
	},
	avg: {
		mongoConvertor: (...args) => ({
			$avg: [...args]
		}),
		numArguments: 2,
		allowMultiple: true,
		mongoAggConvertor: expr => ({
			$avg: expr
		}),
		numAggArguments: 1
	},
	max: {
		mongoConvertor: (...args) => ({
			$max: [...args]
		}),
		numArguments: 2,
		allowMultiple: true,
		mongoAggConvertor: expr => ({
			$max: expr
		}),
		numAggArguments: 1
	},
	min: {
		mongoConvertor: (...args) => ({
			$min: [...args]
		}),
		numArguments: 2,
		allowMultiple: true,
		mongoAggConvertor: expr => ({
			$min: expr
		}),
		numAggArguments: 1
	},
	/**
	 * Array Operators
	 */
	slice: {
		mongoConvertor: (expr1, expr2, expr3) => ({
			$slice: [expr1, expr2, expr3]
		}),
		numArguments: 3
	},
	size: {
		mongoConvertor: expr1 => ({
			$size: {
				$cond: [
					{
						$or: [
							{
								$eq: [expr1, null]
							},
							{
								$eq: [
									{
										$type: expr1
									},
									"missing"
								]
							}
						]
					},
					[],
					expr1
				]
			}
		}),
		numArguments: 1
	},
	push: {
		mongoAggConvertor: expr => ({
			$push: expr
		}),
		numAggArguments: 1
	},
	addToSet: {
		mongoAggConvertor: expr => ({
			$addToSet: expr
		}),
		numAggArguments: 1
	},
	element: {
		mongoConvertor: (expr1, expr2) => ({
			$arrayElemAt: [expr1, expr2]
		}),
		numArguments: 2
	},
	index: {
		mongoConvertor: (expr1, expr2) => ({
			$indexOfArray: [expr1, expr2]
		}),
		numArguments: 2
	},
	/**
	 * Comparison Operators
	 */
	eq: {
		mongoConvertor: (expr1, expr2) => ({
			$eq: [expr1, expr2]
		}),
		numArguments: 2
	},
	gt: {
		mongoConvertor: (expr1, expr2) => ({
			$gt: [expr1, expr2]
		}),
		numArguments: 2
	},
	gte: {
		mongoConvertor: (expr1, expr2) => ({
			$gte: [expr1, expr2]
		}),
		numArguments: 2
	},
	lt: {
		mongoConvertor: (expr1, expr2) => ({
			$lt: [expr1, expr2]
		}),
		numArguments: 2
	},
	lte: {
		mongoConvertor: (expr1, expr2) => ({
			$lte: [expr1, expr2]
		}),
		numArguments: 2
	},
	ne: {
		mongoConvertor: (expr1, expr2) => ({
			$ne: [expr1, expr2]
		}),
		numArguments: 2
	},
	in: {
		mongoConvertor: (expr1, expr2) => ({
			$in: [expr1, expr2]
		}),
		numArguments: 2
	},
	len: {
		mongoConvertor: expr1 => ({
			$strLenCP: expr1
		}),
		numArguments: 1
	},
	/**
	 * Boolean Operator
	 */
	and: {
		mongoConvertor: (...args) => ({
			$and: [...args]
		}),
		numArguments: 2,
		allowMultiple: true
	},
	or: {
		mongoConvertor: (...args) => ({
			$or: [...args]
		}),
		numArguments: 2,
		allowMultiple: true
	},
	not: {
		mongoConvertor: expr => ({
			$not: [expr]
		}),
		numArguments: 1
	},
	/**
	 * Conditional Operators
	 */
	if: {
		mongoConvertor: (expr1, expr2, expr3) => ({
			$cond: [expr1, expr2, expr3]
		}),
		numArguments: 3
	},
	ifNull: {
		mongoConvertor: (expr1, expr2) => ({
			$ifNull: [expr1, expr2]
		}),
		numArguments: 2
	},
	dateFromString: {
		mongoConvertor: expr1 => ({
			$dateFromString: {
				dateString: expr1
			}
		}),
		numArguments: 1
	},
	dateToString: {
		mongoConvertor: expr1 => ({
			$dateToString: {
				date: expr1,
				format: "%Y-%m-%dT%H:%M:%S.%LZ"
			}
		}),
		numArguments: 1
	},
	mid: {
		mongoConvertor: (expr1, expr2, expr3) => ({
			$substrCP: [
				expr1,
				{
					$subtract: [expr2, 1]
				},
				expr3
			]
		}),
		numArguments: 3
	},
	objectToArray: {
		mongoConvertor: expr1 => ({
			$objectToArray: expr1
		}),
		numArguments: 1
	},
	arrayToObject: {
		mongoConvertor: expr1 => ({
			$arrayToObject: expr1
		}),
		numArguments: 1
	},
	concat: {
		mongoConvertor: (...args) => ({
			$concat: [
				...args.map(arg => {
					return { $substr: [arg, 0, -1] };
				})
			]
		}),
		numArguments: 2,
		allowMultiple: true
	},
	concatArrays: {
		mongoConvertor: (...args) => ({
			$concatArrays: [...args]
		}),
		numArguments: 2,
		allowMultiple: true
	},
	dayYear: {
		mongoConvertor: expr1 => ({
			$dayOfYear: expr1
		}),
		numArguments: 1
	},
	day: {
		mongoConvertor: expr1 => ({
			$dayOfMonth: expr1
		}),
		numArguments: 1
	},
	month: {
		mongoConvertor: expr1 => ({
			$month: expr1
		}),
		numArguments: 1
	},
	year: {
		mongoConvertor: expr1 => ({
			$year: expr1
		}),
		numArguments: 1
	},
	add: {
		mongoConvertor: (...args) => ({
			$add: [...args]
		}),
		numArguments: 2,
		allowMultiple: true
	},
	push: {
		mongoConvertor: (...args) => [...args],
		numArguments: 2,
		allowMultiple: true
	},
	floor: {
		mongoConvertor: expr1 => ({
			$floor: expr1
		}),
		numArguments: 1
	},
	ceil: {
		mongoConvertor: expr1 => ({
			$ceil: expr1
		}),
		numArguments: 1
	},
	trunc: {
		mongoConvertor: (expr1, expr2) => ({
			$divide: [
				{
					$trunc: {
						$multiply: [
							expr1,
							{
								$pow: [10, expr2]
							}
						]
					}
				},
				{
					$pow: [10, expr2]
				}
			]
		}),
		numArguments: 2
	},
	find: {
		mongoConvertor: (expr1, expr2) => {
			expr2 = expr2.toString();
			return {
				$cond: [{ $gt: [expr1, null] }, { $sum: [{ $indexOfCP: [expr1, expr2] }, 1] }, 0]
			};
		},
		numArguments: 2
	},
	split: {
		mongoConvertor: (expr1, expr2) => {
			expr2 = expr2.toString();
			return {
				$split: [expr1, expr2]
			};
		},
		numArguments: 2
	},
	upper: {
		mongoConvertor: expr => ({
			$toUpper: expr
		}),
		numArguments: 1
	},
	lower: {
		mongoConvertor: expr => ({
			$toLower: expr
		}),
		numArguments: 1
	},
	type: {
		mongoConvertor: expr => ({
			$type: expr
		}),
		numArguments: 1
	},
	kv: {
		mongoConvertor: (expr1, expr2) => [expr1, expr2],
		numArguments: 2
	},
	obj: {
		mongoConvertor: (...args) => {
			let convertedObject = {};
			args.map(arg => {
				convertedObject[arg[0]] = arg[1];
			});
			return convertedObject;
		},
		numArguments: 1,
		allowMultiple: true
	},
	case: {
		mongoConvertor: (expr1, expr2) => [expr1, expr2],
		numArguments: 2
	},
	switch: {
		mongoConvertor: (arg1, ...args) => {
			let computedBranches = [];
			args.map(arg => {
				computedBranches.push({
					case: { $eq: [arg1, arg[0]] },
					then: arg[1]
				});
			});
			return {
				$switch: { branches: computedBranches, default: 0 }
			};
		},
		numArguments: 1,
		allowMultiple: true
	},
	null: {
		mongoConvertor: () => {
			return null;
		},
		numArguments: 0
	},
	toString: {
		mongoConvertor: expr => ({
			$toString: expr
		}),
		numArguments: 1
	},
	toBool: {
		mongoConvertor: expr => ({
			$toBool: expr
		}),
		numArguments: 1
	},
	toDate: {
		mongoConvertor: expr => ({
			$toDate: expr
		}),
		numArguments: 1
	},
	toDecimal: {
		mongoConvertor: expr => ({
			$toDecimal: expr
		}),
		numArguments: 1
	},
	toDouble: {
		mongoConvertor: expr => ({
			$toDouble: expr
		}),
		numArguments: 1
	},
	toInt: {
		mongoConvertor: expr => ({
			$toInt: expr
		}),
		numArguments: 1
	},
	toLong: {
		mongoConvertor: expr => ({
			$toLong: expr
		}),
		numArguments: 1
	},
	toObjectId: {
		mongoConvertor: expr => ({
			$toObjectId: expr
		}),
		numArguments: 1
	},
	toLower: {
		mongoConvertor: expr => ({
			$toLower: expr
		}),
		numArguments: 1
	},
	toUpper: {
		mongoConvertor: expr => ({
			$toUpper: expr
		}),
		numArguments: 1
	},
	convert: {
		mongoConvertor: (expr1, expr2) => ({
			$convert: { input: expr1, to: expr2 }
		}),
		numArguments: 2
	}
};

export default expressionConfig;
